import React, { useContext, useEffect, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import Menu from '../../../common/menu';

const Signer = ({ id, signer, onUpdateSigner, onDeleteSigner, formVersionDetails, moveCard, index }) => {
  const { created_on, published_on, archived_on } = formVersionDetails || {};
  const ref = useRef(null);
  const ItemTypes = {
    CARD: 'card',
  };
  const [{ handlerId }, drop] = useDrop({
    accept: ItemTypes.CARD,
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.CARD,
    item: () => {
      return { id, index };
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));
  const style = {
    border: '1px dashed gray',
    padding: '0.5rem 1rem',
    marginBottom: '.5rem',
    backgroundColor: 'white',
    cursor: 'move',
  };
  return (
    <div
      ref={ref}
      style={{ opacity }}
      className="flex no-select items-center justify-start w-full divider-bottom item-container cursor automation-log-hover"
      data-handler-id={handlerId}>
      <div className={`flex items-center`}>
        <span className="regular-text one-line ml-4">{signer?.name}</span>
      </div>
      {(!created_on || !published_on || archived_on) && (
        <Menu
          menuList={[
            { name: 'Update', onClick: () => onUpdateSigner(signer) },
            { name: 'Delete', onClick: () => onDeleteSigner(signer) },
          ]}
        />
      )}
    </div>
  );
};

export default Signer;
